import { Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { msgTypes } from 'constants/msgTypes';
import React, { useEffect, useState } from 'react'
import { FinancialProtectionService } from 'services/menu/financialProtection/FinancialProtectionService';
import ApiUrl from 'services/shared/ApiUrl';
import DownloadIcon from '@mui/icons-material/Download';

const DisplayFinancialProtection = () => {
    const [financialProtectionList, setFinancialProtectionList] = useState([]);

    useEffect(() => {
        getFinancialProtectionList();
    }, [])

    //Get Financial Protection list
    const getFinancialProtectionList = async () => {
        const res = await FinancialProtectionService.getFinancialList(msgTypes.EMPTY_STR);
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            if (res.data !== '') {
                const activeGuideLines = res.data.filter(data => {
                    return data.status === true
                })
                setFinancialProtectionList(activeGuideLines);
            } else {
                setFinancialProtectionList([]);
            }
        }
    }

    return (
        <div className='container'>
            <div className='row'>
                {financialProtectionList.length > 0 ? (<>
                    {financialProtectionList.map(data => {
                        return (
                            <div className='col-lg-4 col-md-6'>
                                <Card className='p-2 border finan-margin'>
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="div">
                                            {data.financialProtectionHeading}
                                        </Typography>
                                        <Typography className='text-height' variant="body2" sx={{ color: 'text.secondary' }}>
                                            {data.financialProtectionMessage}
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <a href={ApiUrl.fileBaseUrl+data.attachment} target='_blank'> <Button className='btn btn-certi view-button'  sx={{ mt: 2, backgroundColor: "#F29E2F", width: "100%" }} >< DownloadIcon fontSize="small" /> &nbsp; Download</Button></a>
                                    </CardActions>
                                </Card>

                            </div>
                        )
                    })}
                </>) : (<>
                    <div className="no-data-found pb-4 d-table h-100 text-center">
                        <div className="no-announcement-record">
                            <img src="/images/no-data-found.png" alt="" />
                            <p className="text-center">There is no guidelines.</p>
                        </div>
                    </div>
                </>)}
            </div>

        </div>
    )
}

export default DisplayFinancialProtection